import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["id"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import { postMainApi, putMainApi, deleteMainApi, getMainApi, getSecureAccountsApi, postSecureAccountsApi, putAccountsApi, deleteAccountsApi } from "@Shared/utils/ajax";
import { EMAIL_TEMPLATE_TYPES } from "@Shared/utils/constants";
export const getBoards = async params => {
  return getMainApi(params, "/client/board");
};
export const getBoardCollaborators = async boardId => {
  return getMainApi({}, `/client/board/${boardId}/collaborator`);
};
export const orderBoards = async payload => {
  const endpoint = `/client/board`;
  return putMainApi(payload, endpoint);
};
export const updateStatusOrder = async (boardId, data) => {
  return putMainApi(data, `/client/board/${boardId}/status/order`);
};
export const setBoardAsDefault = async boardId => {
  return putMainApi({
    defaultBoard: true
  }, `/client/board/${boardId}`);
};
export const createBoardStatus = async (boardId, data) => {
  return postMainApi(data, `/client/board/${boardId}/status`);
};
export const updateBoardStatus = async (boardId, id, data) => {
  return putMainApi(data, `/client/board/${boardId}/status/${id}`);
};
export const deleteBoardStatus = async (boardId, id) => {
  return deleteMainApi(`/client/board/${boardId}/status/${id}`);
};
export const updateBoard = async (boardId, data) => {
  return putMainApi(data, `/client/board/${boardId}`);
};
export const createBoard = async data => {
  return postMainApi(data, "/client/board");
};
export const duplicateBoard = async data => {
  return postMainApi(data, "/client/board/duplicate");
};
export const deleteBoard = async boardId => {
  return deleteMainApi(`/client/board/${boardId}`);
};
export const updateCollaboratorSettings = async (boardId, collaboratorId, data) => {
  const endpoint = `/client/board/${boardId}/collaborator/${collaboratorId}`;
  return putMainApi(data, endpoint);
};
export const addBoardCollaborator = async (boardId, username) => {
  return postMainApi({
    collaborator: username
  }, `/client/board/${boardId}/collaborator`);
};
export const removeBoardCollaborator = async (boardId, username) => {
  return deleteMainApi(`/client/board/${boardId}/collaborator/${username}`);
};
export const removeSelfFromBoard = async (boardId, collaborationId) => {
  return deleteMainApi(`/client/board/${boardId}/collaborator/${collaborationId}`);
};
export const setBoardSortBy = async (boardId, sortBy, noActivityFirst, sortByOrder) => {
  return putMainApi({
    sortBy,
    noActivityFirst,
    sortByOrder
  }, `/client/board/${boardId}`);
};
export const getCustomFieldsDeclarations = async boardId => {
  const endpoint = `/client/board/${boardId}/custom-field`;
  return getMainApi({}, endpoint);
};
export const createCustomFieldDeclaration = async (boardId, customFieldDefinition) => {
  const endpoint = `/client/board/${boardId}/custom-field`;
  return postMainApi(customFieldDefinition, endpoint);
};
export const updateCustomFieldDeclaration = async (boardId, _ref) => {
  let {
      id: customFieldDefinitionId
    } = _ref,
    customFieldDefinition = _objectWithoutProperties(_ref, _excluded);
  const endpoint = `/client/board/${boardId}/custom-field/${customFieldDefinitionId}`;
  return putMainApi(customFieldDefinition, endpoint);
};
export const updateCustomFieldOrder = async (boardId, payload) => {
  const endpoint = `/client/board/${boardId}/custom-field`;
  return putMainApi(payload, endpoint);
};
export const deleteCustomFieldDeclaration = async (boardId, customFieldDefinitionId) => {
  const endpoint = `/client/board/${boardId}/custom-field/${customFieldDefinitionId}`;
  return deleteMainApi(endpoint);
};
export const getBoardClientProfiles = async (boardId, offset, limit) => {
  return getMainApi({
    boardId,
    offset,
    limit
  }, `/client/profile`);
};
export const updateProfileDetails = async (clientProfileId, details) => {
  const detailsKeys = _Object$keys(details);
  const isActiveUpdate = detailsKeys.length === 1 && _includesInstanceProperty(detailsKeys).call(detailsKeys, "active");
  return putMainApi(_objectSpread(_objectSpread({}, details), {}, {
    active: !isActiveUpdate ? null : details.active
  }), `/client/profile/${clientProfileId}`);
};
export const downloadDocument = async () => {
  const endpoint = "/client/profile/download";
  return getMainApi({}, endpoint);
};
export const addNote = async (clientProfileId, note) => {
  return postMainApi({
    note
  }, `/client/profile/${clientProfileId}/note`);
};
export const addFollowUp = async (clientProfileId, details) => {
  return postMainApi(details, `/client/profile/${clientProfileId}/follow-up`);
};
export const transferClientProfile = async (boardId, clientProfileId, statusLabelId) => {
  return putMainApi({
    boardId,
    currentStatusLabelId: statusLabelId
  }, `/client/profile/${clientProfileId}/move`);
};
export const updateFollowUp = async (clientProfileId, followUpId, data) => {
  return await putMainApi(data, `/client/profile/${clientProfileId}/follow-up/${followUpId}`);
};
export const createNewProfile = async (data, boardId) => {
  if (!data.value) data.value = 0;
  return postMainApi(data, `/client/profile?boardId=${boardId}`);
};
export const getDuplicateClients = async data => {
  const endpoint = `/client/duplicate`;
  return getMainApi(data, endpoint);
};
export const getNotifiedReferrers = async clientProfileId => {
  return getMainApi({}, `/client/profile/${clientProfileId}/subscriber`);
};
export const getProfileCollaborators = async clientProfileId => {
  return getMainApi({}, `/client/profile/${clientProfileId}/collaborator`);
};
export const addClientProfileCollaborator = (clientProfileId, username) => {
  return postMainApi({
    collaborator: username
  }, `/client/profile/${clientProfileId}/collaborator`);
};
export const removeProfileCollaborator = (clientProfileId, username) => {
  return deleteMainApi(`/client/profile/${clientProfileId}/collaborator/${username}`);
};
export const updateCollaboratorEmailSync = (clientProfileId, collaborator, trackEmails) => {
  return putMainApi({
    trackEmails
  }, `/client/profile/${clientProfileId}/collaborator/${collaborator}`);
};
export const getProfileDetails = async id => {
  return getMainApi({}, `/client/profile/${id}`);
};
export const linkApplication = async (clientProfileId, accountUsername) => {
  return putMainApi({
    accountUsername
  }, `/client/profile/${clientProfileId}/link-account`);
};
export const subscribeReferrers = async (clientProfileId, subscribers) => {
  return postMainApi({
    subscriberList: subscribers
  }, `/client/profile/${clientProfileId}/subscriber`);
};
export const unsubscribeReferrer = async (clientProfileId, referrerId) => {
  return deleteMainApi(`/client/profile/${clientProfileId}/subscriber/${referrerId}`);
};
export const getTimeline = async (clientProfileId, limit, offset) => {
  return getMainApi({
    limit,
    offset
  }, `/client/profile/${clientProfileId}/timeline`);
};
export const togglePin = async (clientProfileId, timelineItem, id) => {
  return postMainApi({}, `/client/profile/${clientProfileId}/${timelineItem}/${id}/pin`);
};
export const createChecklist = async (clientProfileId, checklist, title) => {
  return postMainApi({
    checklist,
    title
  }, `/client/profile/${clientProfileId}/checklist`);
};
export const sendNoteToReferrers = async (clientProfileId, noteId) => {
  return postMainApi({}, `/client/profile/${clientProfileId}/note/${noteId}/notify`);
};
export const updateNote = async (clientProfileId, noteId, data) => {
  return putMainApi(data, `/client/profile/${clientProfileId}/note/${noteId}`);
};
export const saveChecklist = async (clientProfileId, checklistId, items, title) => {
  return putMainApi({
    checklist: items,
    title
  }, `/client/profile/${clientProfileId}/checklist/${checklistId}`);
};
export const deleteFollowUp = async (clientProfileId, followUpId) => {
  return await deleteMainApi(`/client/profile/${clientProfileId}/follow-up/${followUpId}`);
};
export const deleteClientProfile = async clientProfileId => {
  return deleteMainApi(`/client/profile/${clientProfileId}`);
};
export const getChangelog = async (clientProfileId, {
  offset,
  limit,
  lastChanges
}) => {
  return getMainApi({
    lastChanges,
    offset,
    limit
  }, `/client/profile/${clientProfileId}/changelog`);
};
export const addFollowUpAssignee = async (clientProfileId, followUpId, assignees = []) => {
  return await postMainApi({
    assignees
  }, `/client/profile/${clientProfileId}/follow-up/${followUpId}/assignee`);
};
export const deleteFollowUpAssignee = async (clientProfileId, followUpId, assignee = "") => {
  return await deleteMainApi(`/client/profile/${clientProfileId}/follow-up/${followUpId}/assignee/${assignee}`);
};
export const deleteNote = async (clientProfileId, noteId) => {
  return await deleteMainApi(`/client/profile/${clientProfileId}/note/${noteId}`);
};
export const deleteEmail = async (clientProfileId, emailId) => {
  return deleteMainApi(`/client/profile/${clientProfileId}/email/${emailId}`);
};
export const getEmailBody = async (clientProfileId, emailId) => {
  return getMainApi({}, `/client/profile/${clientProfileId}/email/${emailId}`);
};
export const deleteChecklist = async (clientProfileId, checklistId) => {
  return deleteMainApi(`/client/profile/${clientProfileId}/checklist/${checklistId}`);
};
export const getEmailTemplates = async () => {
  return getSecureAccountsApi({
    templateType: EMAIL_TEMPLATE_TYPES.CLIENT_PROFILE
  }, "/email/template");
};
export const getChecklistTemplates = async () => {
  return getSecureAccountsApi({}, "/checklist/templates");
};
export const getTemplate = async templateId => {
  const {
    template
  } = await getSecureAccountsApi({}, `/email/template/${templateId}`);
  return template;
};
export const saveEmailTemplate = async emailData => {
  return postSecureAccountsApi(emailData, "/email/template");
};
export const saveChecklistTemplate = async checklistData => {
  return postSecureAccountsApi(checklistData, "/checklist/templates");
};
export const updateEmailTemplate = async (templateId, emailData) => {
  return putAccountsApi(emailData, `/email/template/${templateId}`);
};
export const deleteEmailTemplate = async templateId => {
  return deleteAccountsApi(`/email/template/${templateId}`);
};
export const deleteChecklistTemplate = async templateId => {
  return deleteAccountsApi(`/checklist/templates/${templateId}`);
};
export const sendEmail = async (clientProfileId, emailData, applicationId) => {
  const endpoint = clientProfileId ? `/client/profile/${clientProfileId}/email` : `/application/${applicationId}/email`;
  return postMainApi(emailData, endpoint);
};
export const changeOwner = async (clientProfileId, newOwner) => {
  return putMainApi({
    username: newOwner
  }, `/client/profile/${clientProfileId}/transfer`);
};
export const duplicateClientProfile = async (clientProfileId, pinnedApplication = null, labelText, labelColour) => {
  return postMainApi({
    pinnedApplication,
    labelText,
    labelColour
  }, `/client/profile/${clientProfileId}/duplicate`);
};
export const updateProfileLabel = async (clientProfileId, labelText, labelColour) => {
  return putMainApi({
    labelText,
    labelColour
  }, `/client/profile/${clientProfileId}/profile-label`);
};
export const getBoardChangelog = async (boardId, {
  limit,
  offset,
  compact
}) => {
  return getMainApi({
    limit,
    offset,
    compact
  }, `/client/board/${boardId}/profiles/changelog`);
};
export const getClientLists = async clientProfileId => {
  const endpoint = `/client/profile/${clientProfileId}/remarketing/list`;
  return getMainApi({}, endpoint);
};
export const getClientCampaigns = async clientProfileId => {
  const endpoint = `/client/profile/${clientProfileId}/remarketing/campaign`;
  return getMainApi({}, endpoint);
};
export const mergeClientProfile = async (clientProfileOriginId, clientProfileToMergeId, mergeData) => {
  return postMainApi(mergeData, `/client/profile/${clientProfileOriginId}/merge/${clientProfileToMergeId}`);
};
export const batchTransferClientProfiles = async params => {
  return putMainApi(_objectSpread(_objectSpread({}, params), {}, {
    toStatusLabelId: params.toStatusLabelId || null
  }), "/client/profile/move");
};
export const moveEmailAttachment = (clientProfileId, applicationId, emailId, files, documentRequestId, documentType) => {
  const endpoint = `/client/profile/${clientProfileId}/email/${emailId}/file/copy`;
  return postMainApi({
    applicationId,
    emailId,
    files,
    documentRequestId,
    documentType
  }, endpoint);
};
export const synchronizeLinkedApplication = (clientProfileId, applicationId) => {
  const endpoint = `/client/profile/${clientProfileId}/synchronize`;
  return postMainApi({
    applicationId
  }, endpoint);
};
export const changeMasterSubscription = (clientProfileId, unsubscribe) => {
  const endpoint = `/client/profile/${clientProfileId}/email-notifications-update`;
  return putMainApi({
    unsubscribe
  }, endpoint);
};
export const getParticipants = async (username, clientProfileId) => {
  return getMainApi({}, `/client/profile/${clientProfileId}/participant`);
};
export const addParticipant = async (username, clientProfileId, data) => {
  return postMainApi(data, `/client/profile/${clientProfileId}/participant`);
};
export const updateParticipant = async (username, clientProfileId, participantId, data) => {
  return putMainApi(data, `/client/profile/${clientProfileId}/participant/${participantId}`);
};
export const updateParticipantOrder = async (username, clientProfileId, orderedIds) => {
  return putMainApi(orderedIds, `/client/profile/${clientProfileId}/participant`);
};
export const deleteParticipant = async (username, clientProfileId, participantId) => {
  return deleteMainApi(`/client/profile/${clientProfileId}/participant/${participantId}`);
};